export default __webpack_public_path__ + "static/media/box_sticker_reduced.075121e8.jpg";